// Vocabulário das automações em linguagem do usuário (não-técnico).

export const TRIGGERS = {
    BUDGET_CREATED: 'budget_created',
    ORDER_CREATED: 'order_created',
    CARD_ENTERED_STAGE: 'card_entered_stage',
};

export const ACTIONS = {
    CREATE_CARD: 'create_card',
    CREATE_TASK: 'create_task',
};

export const actionForTrigger = (trigger) =>
    trigger === TRIGGERS.CARD_ENTERED_STAGE ? ACTIONS.CREATE_TASK : ACTIONS.CREATE_CARD;

// Passo 1 de "Nova automação": cartões grandes para escolher o gatilho.
export const triggerOptions = [
    {
        value: TRIGGERS.BUDGET_CREATED,
        icon: '📥',
        title: 'Chegar um novo orçamento',
        description: 'Quando um cliente pedir um orçamento.',
    },
    {
        value: TRIGGERS.ORDER_CREATED,
        icon: '🧾',
        title: 'Chegar um novo pedido',
        description: 'Quando um pedido for feito.',
    },
    {
        value: TRIGGERS.CARD_ENTERED_STAGE,
        icon: '➡️',
        title: 'Um card entrar numa coluna',
        description: 'Quando um card chegar numa coluna do painel.',
    },
];

// Título de cada grupo na lista de automações.
export const triggerGroupTitle = (trigger) => ({
    [TRIGGERS.BUDGET_CREATED]: 'Quando chega um novo orçamento',
    [TRIGGERS.ORDER_CREATED]: 'Quando chega um novo pedido',
    [TRIGGERS.CARD_ENTERED_STAGE]: 'Quando um card entra numa coluna',
}[trigger] ?? 'Automações');

// Substantivo usado na frase ("um novo orçamento").
export const triggerNoun = (trigger) => ({
    [TRIGGERS.BUDGET_CREATED]: 'um novo orçamento',
    [TRIGGERS.ORDER_CREATED]: 'um novo pedido',
}[trigger] ?? 'um card');

export const triggerOrdersByPriority = (trigger) =>
    trigger === TRIGGERS.BUDGET_CREATED || trigger === TRIGGERS.ORDER_CREATED;

// Condição: origem. Pedido é sempre "sistema", então só aparece para orçamento.
export const originOptions = [
    { value: 'site', label: 'Site' },
    { value: 'sistema', label: 'Sistema' },
];
export const originLabel = (v) => originOptions.find((o) => o.value === v)?.label ?? v;

// Condição: valor.
export const amountOperatorOptions = [
    { value: 'gte', label: 'maior ou igual a' },
    { value: 'lt', label: 'menor que' },
];
export const amountOperatorLabel = (v) =>
    amountOperatorOptions.find((o) => o.value === v)?.label ?? 'maior ou igual a';

export const CONDITION_TYPES = { ORIGIN: 'origin', AMOUNT: 'amount' };

// Tipos de tarefa (espelha os rótulos do board).
export const taskTypeOptions = [
    { value: 'call', label: 'Ligação' },
    { value: 'meeting', label: 'Reunião' },
    { value: 'email', label: 'E-mail' },
    { value: 'task', label: 'Tarefa' },
];
export const taskTypeLabel = (v) => taskTypeOptions.find((o) => o.value === v)?.label ?? 'Tarefa';

// Prazo da tarefa.
export const taskDueOptions = [
    { value: 0, label: 'no mesmo dia' },
    { value: 1, label: 'em 1 dia' },
    { value: 3, label: 'em 3 dias' },
    { value: 7, label: 'em 7 dias' },
    { value: 15, label: 'em 15 dias' },
];
export const taskDueLabel = (v) =>
    taskDueOptions.find((o) => o.value === Number(v))?.label ?? `em ${v} dias`;

// Pedido: como criar o card.
export const cardModeOptions = [
    { value: 'per_product', label: 'um card por produto' },
    { value: 'per_order', label: 'um card por pedido' },
];
export const cardModeLabel = (v) =>
    cardModeOptions.find((o) => o.value === v)?.label ?? 'um card por produto';

// Pedido: responsável pelo card.
export const responsibleModeOptions = [
    { value: 'none', label: 'sem responsável' },
    { value: 'order_admin', label: 'quem vendeu' },
    { value: 'fixed_admin', label: 'uma pessoa fixa' },
];
export const responsibleModeLabel = (v) =>
    responsibleModeOptions.find((o) => o.value === v)?.label ?? 'quem vendeu';
